import React from 'react';
import './App.css';

function App() {
  return (
    <div className="unavailable-container">
      <div className="message-box">
        <h1>Sorry</h1>
        <p>This site is no longer available.</p>
        <div className="decoration"></div>
      </div>
    </div>
  );
}

export default App;
